export const SET_CATALOG_TARIFS = 'SET_CATALOG_TARIFS';
export const SET_IS_LOADING_CATALOG_TARIFS = 'SET_IS_LOADING_CATALOG_TARIFS';
export const SELECT_TARIF = 'SELECT_TARIF';
export const SET_IS_LOADING_CREATE_TARIF = 'SET_IS_LOADING_CREATE_TARIF';
export const SET_IS_LOADING_UPDATE_TARIF = 'SET_IS_LOADING_UPDATE_TARIF';
export const DELETE_TARIF = 'DELETE_TARIF';
export const IS_LOADING_DELETE_TARIF = 'IS_LOADING_DELETE_TARIF';
export const IS_LOADING_DOWNLOAD_TARIF = 'IS_LOADING_DOWNLOAD_TARIF';
export const RESET_CATALOG_TARIFS = 'RESET_CATALOG_TARIFS';